import React from 'react';
import {GoogleMapsLink} from "../atoms/GoogleMapsLink";

export const Footer = () => (
  <footer>
    <div className={"footer-container"}><span>&copy;	Copyright 2025 irongirl.nl</span></div>
  </footer>
);
